import { useMemo } from "react";
import useAuthStore from "~/store/auth";
import { RoleV2 } from "~/types";

export function useIsAuthorized(roles: RoleV2[]) {
  const superAdmin = useAuthStore((state) => state.superAdmin);
  const userInfo = useAuthStore((state) => state.userInfo);
  const memberRoles = useMemo(() => (userInfo?.roles || []).map((r) => r.role), [userInfo]);

  if (superAdmin) {
    return true;
  }

  if (roles.length === 0) return true;

  return (
    roles.some((role) => {
      return memberRoles.includes(role);
    }) || superAdmin
  );
}

export function useIsAuthorizedFn() {
  const superAdmin = useAuthStore((state) => state.superAdmin);
  const userInfo = useAuthStore((state) => state.userInfo);
  const memberRoles = useMemo(() => (userInfo?.roles || []).map((r) => r.role), [userInfo]);

  return (roles: RoleV2[]) => {
    if (superAdmin) {
      return true;
    }

    return (
      roles.some((role) => {
        return memberRoles.includes(role);
      }) || superAdmin
    );
  };
}

export function useIsSuperAdmin() {
  const superAdmin = useAuthStore((state) => state.superAdmin);
  return superAdmin;
}

export function useIsTrader() {
  return useIsAuthorized([RoleV2.TRADER]);
}

export function useIsFinOps() {
  return useIsAuthorized([RoleV2.FINOPS]);
}

export function useIsAdmin() {
  return useIsAuthorized([RoleV2.ADMIN]);
}

export function useIsAuditor() {
  return useIsAuthorized([RoleV2.AUDITOR]);
}

export function useIsOnboardingRole() {
  return useIsAuthorized([RoleV2.ONBOARDING]);
}
